import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { alpha, useTheme } from '@mui/material/styles'
import { useSmartTranslation } from '../../../../generic/hooks/useSmartTranslation'
import { CONTROL_RADIUS } from '../detailControls'
import { PartChip } from './PartsGrid'

// The cancelled parts of the order: a count that is always read, and a list that folds. The list is
// fetched on its own when it opens (the grid does not carry cancelled parts).
const CancelledPartsSection = ({ cancelledParts, cancelledTotal, expanded, onToggle, loadingMore, onLoadMore, selectedPartId, onSelectPart }) => {
  const { t_ } = useSmartTranslation()
  const theme = useTheme()
  const cancelledExpanded = expanded
  const cancelledRows = cancelledParts.content
  const loadingMoreCancelled = loadingMore

  return (
    <Box
      data-testid='parts-cancelled-group'
      sx={{
        mt: 2.5,
        borderRadius: 2,
        border: `1px solid ${alpha(theme.palette.text.primary, 0.08)}`,
        p: 2.5
      }}
    >
      {/* ⚠️⚠️ LA LISTA SE PLIEGA; EL RECUENTO NO. Son 20 de las 30 piezas de esta orden, así que
      ocupaban dos tercios de la rejilla para decir lo mismo veinte veces. Lo que se esconde
      es la lista — el número sigue a la vista en el desglose de arriba («20 Cancelled») y
      aquí mismo, en el rótulo. Si desapareciera con ellas, la pantalla estaría diciendo que
      la orden tiene diez piezas.
      📌 Plegado por defecto, no oculto: §2.3, la misma regla del pie de General y de los
      grupos vacíos de Documentos. El botón dice CUÁNTAS hay detrás, que es lo que convierte
      «hay algo plegado» en «hay veinte piezas canceladas plegadas». */}
      <Stack direction='row' spacing={2} alignItems='center' justifyContent='space-between' flexWrap='wrap' sx={{ rowGap: 1 }}>
        {/* ⚠️⚠️ DOS CIFRAS, Y NO UNA, PORQUE UNA SOLA MENTIRÍA. `cancelledRows` son las
        canceladas DE LA PÁGINA CARGADA, no las de la orden: con 30 piezas y página de 20
        salen 17, mientras el desglose de arriba dice 20 —el `totalElements` que sirve Sun—.
        Poner solo la primera repetiría aquí el defecto que este mismo bloque acaba de
        quitar (contar filas en vez de preguntar al servidor), y además dejaría dos números
        distintos para lo mismo a diez píxeles uno del otro.
        📌 Lo destapó mirar la pantalla: en los tests las dos cifras coincidían. */}
        <Typography variant='caption' sx={{ fontWeight: 800, letterSpacing: 1, textTransform: 'uppercase', color: 'text.secondary' }}>
          {`${t_('Cancelled parts')} · ${t_('Showing {{shown}} of {{total}}', { shown: cancelledParts.content.length, total: cancelledTotal })}`}
        </Typography>
        <Button
          data-testid='parts-cancelled-toggle'
          size='small'
          variant='outlined'
          onClick={onToggle}
          sx={{ textTransform: 'none', borderRadius: CONTROL_RADIUS, minHeight: 44 }}
        >
          {cancelledExpanded ? t_('Hide cancelled parts') : t_('Show cancelled parts')}
        </Button>
      </Stack>
      {cancelledExpanded && (
        <Box data-testid='parts-cancelled-list' sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1.5 }}>
          {cancelledRows.map((part) => (
            <PartChip key={part.partId} part={part} selected={part.partId === selectedPartId} onSelect={onSelectPart} />
          ))}
        </Box>
      )}
      {cancelledExpanded && cancelledParts.content.length < cancelledParts.totalElements && (
        <Button
          data-testid='parts-cancelled-load-more'
          size='small'
          variant='outlined'
          onClick={() => onLoadMore()}
          disabled={loadingMoreCancelled}
          sx={{ mt: 1.5, textTransform: 'none', borderRadius: CONTROL_RADIUS, minHeight: 44 }}
        >
          {loadingMoreCancelled ? t_('Loading...') : t_('Show more parts')}
        </Button>
      )}
    </Box>
  )
}

export default CancelledPartsSection
